import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ImageMetadata } from "../types";
import { FrameMetricTooltip } from "./FrameMetricTooltip";

interface DetectedStarsChartProps {
  imagesForView: ImageMetadata[];
}

const DetectedStarsChart: React.FC<DetectedStarsChartProps> = ({
  imagesForView,
}) => {
  // Only use light frames
  const lightFrames = imagesForView.filter((img) =>
    img.FrameType ? img.FrameType === "LIGHT" : !!img.FilterName
  );

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 3,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        minHeight: 400,
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
      >
        Detected Stars
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Number of stars detected in each frame
      </Typography>
      {lightFrames.length === 0 ? (
        <Typography color="text.secondary">No data available.</Typography>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <LineChart
            data={lightFrames
              .map((img, i) => ({ frame: i + 1, stars: img.DetectedStars }))
              .filter((d) => typeof d.stars === "number" && isFinite(d.stars))}
          >
            <XAxis
              dataKey="frame"
              stroke="#a0a0a0"
              tick={{ fill: "#a0a0a0" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
            />
            <YAxis
              stroke="#a0a0a0"
              tick={{ fill: "#a0a0a0" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
              domain={[0, "auto"]}
            />
            <Tooltip content={<FrameMetricTooltip labelName="Star Count" />} />
            <Line
              type="monotone"
              dataKey="stars"
              stroke="#4caf50"
              strokeWidth={2}
              dot={{ r: 2, fill: "#4caf50" }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};

export default DetectedStarsChart;
